<ng-container *ngIf="checkCanSet">
    <marquee *ngIf="checkCanSet.is_active==null" behavior="" direction=""><span class="text-danger fw-bold">{{checkCanSet.alert_message}}</span></marquee>
    <marquee *ngIf="checkCanSet.is_active==1" behavior="" direction=""><span class="text-info fw-bold">Vous ne pouvez plus publier de note pour cette période</span></marquee>
</ng-container>


<div class="row">
    <div class="col-12">
        <div class=" text-center border" >
            <div class="ag-bg-red  row no-gutters  p-1" style="height: 3rem; border-radius: 10px 10px 0px 0px;">
                <span class="text-white col-12 col-md-2">Interrogation/Devoir</span>
                <span class="text-white col-12 col-md-2">Matière</span>
                <span class="text-white col-12 col-md-3">Professeur</span>
                <span class="text-white col-12 col-md-1">Salle</span>
                <span class="text-white col-12 col-md-2">Date</span>
                <span class="text-white col-12 col-md-2">Action</span>
            </div>
            <div class="p-1" style="height: 70vh; overflow-y: scroll; ">
                <div class="row no-gutters border mb-3" *ngFor="let d of data">
                      <div class="col-12 col-md-2">
                        <dl>
                            <dt>{{d.type}}</dt>
                            <dd>{{d.name}}</dd>
                        </dl>
                      </div>
                      <div class="col-12 col-md-2">{{d.pacc?.course?.name}}</div>
                      <div class="col-12 col-md-3">{{d.pacc?.pac?.professor?.lastname}} {{d.pacc?.pac?.professor?.firstname}}</div>
                      <div class="col-12 col-md-1">{{d.room?.name}}</div>
                      <div class="col-12 col-md-2">{{d.programming_date | date:"dd-MM-yyyy"}}</div>
                      <div class="col-12 col-md-2">
                        <ng-container *ngIf="d.pacc?.pac?.professor?.id == user.professor?.id">
                            <button *ngIf="d.is_active!=null && !d.is_active && d.notes_count==0" (click)="setStatus(1,d.id)" type="button" class="btn btn-outline-success btn-sm btn-label waves-effect waves-light me-3" [disabled]="loading" placement="bottom" ngbTooltip="Publier cette composition">
                                <i class="fa fa-share"></i></button>
                               <button  *ngIf="d.is_active!=null &&  d.is_active && d.notes_count==0" (click)="setStatus(0,d.id)" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3" [disabled]="loading" placement="bottom" ngbTooltip="Annuler cette composition">
                                <i class="fa fa-times"></i></button>
                               <button *ngIf="d.notes_count==0"   (click)="edit(d)"   type="button"  class="btn btn-outline-warning btn-sm btn-label waves-effect waves-light me-3" [disabled]="loading" placement="bottom" ngbTooltip="Modifier cette composition">
                                <i class="fa fa-edit"></i></button>
                               <button *ngIf="d.notes_count==0" (click)="delete(d.id)"  type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3" [disabled]="loading" placement="bottom" ngbTooltip="Supprimer cette composition">
                                <i class="fa fa-trash"></i></button>
                               <button *ngIf="!d.is_confirmed && d.has_note" (click)="confirm(d.id)"  type="button" class="btn btn-outline-success btn-sm btn-label waves-effect waves-light me-3" [disabled]="loading" placement="bottom" ngbTooltip="Confirmer les notes de cette composition">
                                <i class="fa fa-arrow-up"></i></button>
                        </ng-container>
                      
                      </div>
                </div>
             
               
            </div>
        </div>
    </div>
</div>